import store from '@/store';
import axios from "axios";

class Global {
    constructor() {
    }

    static getPayStyles() {
        return {
            '1': 'クレジットカード',
            // '2': '銀行振込',
            // '3': '代引き',
        }
    }

    static getItemStyle() {
        return {
            '1': '販売中',
            '2': '予約商品',
        }
    }

    static getGender() {
        return {
            '1':'男性',
            '2':'女性',
            '99':'未回答',
        }
    }    

    /**
     * 指定されたインデックスの値を返却する
     */
    static getGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    return store.getters.getPostParam[group][index][label];
                } else {
                    return store.getters.getPostParam[group][label];
                }
            } else {
                if (index != null) {
                    if (!store.getters.getPostParam[label]) {
                        return store.getters.getPostParam[label];
                    }
                    return store.getters.getPostParam[label][index];
                }
            }
            return store.getters.getPostParam[label];
        } catch (e) {
        }
        return '';
    }

    /**
     * 指定されたインデックスが存在するかを調べる
     */
    static hasGroupIndexValue(group, index, label) {
        try {
            if (group != null) {
                if (index != null) {
                    if (!store.getters.getPostParam[group][index][label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[group][label]) {
                        return false;
                    }
                }
                return true;
            } else if (index != null) {
                if (!store.getters.getPostParam[label]) {
                    if (!store.getters.getPostParam[label]) {
                        return false;
                    }
                } else {
                    if (!store.getters.getPostParam[label][index]) {
                        return false;
                    }
                }
            } else {
                if (!store.getters.getPostParam[label]) {
                    return false;
                }
            }
            return true;
        } catch (e) {
        }
        return false;
    }

    static checkKeyCode(e) {
        // console.log(e.keyCode);
        switch(e.keyCode) {
            case 8:
            case 46:
            case 37:
            case 38:
            case 39:
            case 40:
                return true;
        }
        if (e.keyCode == 8 || e.keyCode == 46) {
            return true;
        }
        return false;
    }

    static async checkPointHit(targetPoint) {
        var list = await store.getters.getPagePoint;
        for (let i = 0; list.length > i; i ++) {
            if (list[i].point_code == targetPoint) {
                return true;
            }
        }
        return false;
    }

    /**
     * 消費税加算
     */
    static tax(price) {
        return parseInt(price * 1.1, 10);
    }

    /**
     * 数値のカンマ区切りを行う
     */
    static comma(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
}

export default Global;